<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_31026"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16763_31026)">
      <path
        d="M15.7956 16.8353C15.4537 15.8785 14.7004 15.033 13.6526 14.4299C12.6047 13.8269 11.3208 13.5 10 13.5C8.6792 13.5 7.3953 13.8269 6.34743 14.4299C5.29957 15.033 4.5463 15.8785 4.20445 16.8353"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <circle
        cx="10"
        cy="7.5"
        r="3"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
    </g>
  </svg>
</template>
<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
